// extracted by mini-css-extract-plugin
module.exports = {"stockist":"stockist-module--stockist--2sFxZ"};